// ActivationSetsFilter.tsx consts
export const DROPDOWN_PLACEMENT = "ontop-left";
export const DROPDOWN_BUTTON_KEY = "activation-sets-filter-button";
export const DROPDOWN_BUTTON_ICON = "add";
export const DROPDOWN_BUTTON_TEXT_KEY = "activation_sets.filter.button.text";
export const DROPDOWN_ITEM_NO_SETS_CREATED = "activation_sets.filter.no_sets_created";
export const DROPDOWN_SEARCH_PLACEHOLDER = "activation_sets.filter.search.placeholder";
export const DROPDOWN_ERROR_TITLE = "activation_sets.filter.error.title";
export const DROPDOWN_ERROR_SUBTITLE = "activation_sets.filter.error.subtitle";

// ActivationSetsQueryBarFilter.tsx consts
export const ACTIVATION_SETS_QUERY_BAR_ITEM_ICON = "open-folder";
export const ACTIVATION_SETS_QUERY_BAR_ITEM_SECONDARY_TEXT = "activation_sets.query_bar.filter.item.secondary_text";

// CreateActivationSetCTA.tsx consts
export const ICON_NAME = "add";
export const ICON_SIZE = "xs";
export const CREATE_ACTIVATION_SET_TEXT = "activation_sets.create_set.cta.text";
